function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  rx: 2,
  fill: "#F3F3F3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9975 14V13.9995H14.0005V9.59858C14.0005 7.44563 13.537 5.78716 11.0201 5.78716C9.81011 5.78716 8.99813 6.45115 8.66663 7.08063H8.63164V5.98816H6.24519V13.9995H8.73013V10.0326C8.73013 8.98809 8.92813 7.97812 10.2216 7.97812C11.4961 7.97812 11.5151 9.17009 11.5151 10.0996V14H13.9975Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2.19724 5.98837H4.68517V13.9997H2.19724V5.98837Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M3.44096 2C2.64548 2 2 2.64548 2 3.44096C2 4.23644 2.64548 4.89543 3.44096 4.89543C4.23644 4.89543 4.88193 4.23644 4.88193 3.44096C4.88143 2.64548 4.23594 2 3.44096 2V2Z",
  fill: "black"
});

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.1f2de14e.svg";
export { ForwardRef as ReactComponent };